// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TtD3Q","group":"styles_group__OIuTf","groupTitle":"styles_groupTitle__I4zP1","cards":"styles_cards__GAJYq"};